import type { InPageNavigationBlock as InPageNavigationBlockType } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import InPageNavigationBlock from '../blocks/InPageNavigationBlock'

export const InPageNavigationConverter: JSXConverter<
	SerializedBlockNode<InPageNavigationBlockType>
> = ({ node }) => {
	const tabs = node.fields.items ?? []
	return <InPageNavigationBlock tabs={tabs} />
}
